import JobStatus from "../../../model/job/JobStatus";
import JobWarrantyRegistrationStatus from "../../../model/job/JobWarrantyRegistrationStatus";

/**
 * Job statuses fetched successful action.
 */
export const JOB_STATUSES_FETCHED = "JOB_STATUSES_FETCHED";
export type JOB_STATUSES_FETCHED = { jobStatuses: Array<JobStatus> }

/**
 * Create job status successful action.
 */
export const JOB_STATUS_CREATED = "JOB_STATUS_CREATED";
export type JOB_STATUS_CREATED = { jobStatus: JobStatus }

/**
 * Edit job status successful action.
 */
export const JOB_STATUS_EDITED = "JOB_STATUS_EDITED";
export type JOB_STATUS_EDITED = { jobStatus: JobStatus }

/**
 *  Update job status sort order successful action.
 */
export const JOB_STATUS_SORT_ORDER_UPDATED = "JOB_STATUS_SORT_ORDER_UPDATED";
export type JOB_STATUS_SORT_ORDER_UPDATED = { jobStatuses: Array<JobStatus> }

/**
 * Change job status suspend action
 */
export const JOB_STATUS_SUSPEND_UPDATED = "JOB_STATUS_SUSPEND_UPDATED";
export  type JOB_STATUS_SUSPEND_UPDATED = { jobStatusId: string, disabled: boolean };

/**
 * Job warranty registration statuses fetched successful action.
 */
export const JOB_WARRANTY_REGISTRATION_STATUSES_FETCHED = "JOB_WARRANTY_REGISTRATION_STATUSES_FETCHED";
export type JOB_WARRANTY_REGISTRATION_STATUSES_FETCHED = { jobWarrantyRegistrationStatuses: Array<JobWarrantyRegistrationStatus> }
